window.User = (function () {
    var ws;
    var surveyId;

    var checkConnectionState = function () {
        if (!ws || ws.readyState !== 1) {
            console.error('Connection not open', ws);
            return false;
        }
        return true;
    };

    // FIXME: Refactor to be more clean
    function setActiveView(activeView) {
        $('[data-view]').hide();
        if (activeView) {
            $('[data-view=' + activeView + ']').show();
        }
        $('body').removeClass(function (_, css) {
            // Remove all `livesurvey-user-body--` classes
            return (css.match(/\blivesurvey-user-body--\S+/g) || []).join(' ');
        });
        if (activeView) {
            $('body').addClass('livesurvey-user-body--' + activeView);
        }
    }

    var updateQuestionInteraction = function (phase, activeQuestion, numQuestions, numUsers) {
        function hasAnsweredCurrentQuestion() {
            var activeQuestionNum = new Number(activeQuestion.Id);
            var lastAnsweredQuestionStr = window.Common.GetCookie('lastAnswered');
            if (lastAnsweredQuestionStr) {
                var lastAnsweredQuestion = JSON.parse(lastAnsweredQuestionStr);
                if (
                    lastAnsweredQuestion &&
                    lastAnsweredQuestion.surveyId === surveyId &&
                    lastAnsweredQuestion.questionId >= activeQuestionNum
                ) {
                    return true;
                }
            }
            return false;
        }

        function submitAnswer(qId, oId) {
            if (!checkConnectionState()) return;
            ws.send(
                JSON.stringify({
                    surveyId: surveyId,
                    instruction: 'answer',
                    questionId: qId,
                    optionId: oId
                })
            );
            window.Common.SetCookie(
                'lastAnswered',
                JSON.stringify({ surveyId: surveyId, questionId: qId }),
                1
            );
            setActiveView('answered');
        }

        if (phase === 'Initialized') {
            // User has connected, survey not yet started
            setActiveView('initialized');
        } else if (phase === 'ReadyForStart') {
            // Survey is about to start
            setActiveView('rules');
        } else if (phase === 'Active') {
            // The current question can be answered
            $('.js-numUsers').html(numUsers);
            if (hasAnsweredCurrentQuestion()) {
                setActiveView('answered');
            } else {
                if (!$('body').hasClass('livesurvey-user-body--active')) {
                    generateQuestionsMarkup(activeQuestion, submitAnswer);
                }
                setActiveView('active');
            }
        } else if (phase === 'Waiting') {
            // Question is closed
            $('.js-numUsers').html(numUsers);
            setActiveView('waiting');
        } else if (phase === 'Level') {
            // Show level advancement screen
            var level = parseInt(activeQuestion.Level.Id) + 1;
            $('.js-numLevel').html(level);
            $('[data-view=level]').attr('data-level', level);
            $('.user-level__stars .js-star').removeClass('js-star--filled');
            $('.user-level__stars .js-star:lt(' + level + ')').addClass('js-star--filled');
            setActiveView('level');
        } else if (phase === 'QuestionsFinished') {
            // All questions have been answered
            setActiveView('waiting');
        } else if (phase === 'SurveyFinished') {
            // Presenter has finished
            setActiveView('finished');
        }
    };

    function generateQuestionsMarkup(activeQuestion, submitAnswer) {
        $('.js-activeQuestionNum').html(new Number(activeQuestion.Id) + 1);
        var levelNum = activeQuestion.Level.Id + 1;
        var levelMarkup = Array(3)
            .fill()
            .map(function (_, idx) {
                return levelNum > idx
                    ? '<span class="js-star js-star--filled"></span>'
                    : '<span class="js-star"></span>';
            });
        $('.js-activeLevel').html(levelMarkup);
        $('.js-questionDescription').html(activeQuestion.Description.replace(/\n/g, '<br />'));
        $('.js-options').empty();
        $('.js-selectUserOption').removeClass('select-user-option-button--active');

        $('.js-selectUserOption, .user-option-btn').off('click.livesurvey');

        for (var i = 0, l = activeQuestion.Options.length; i < l; i++) {
            var option = activeQuestion.Options[i];
            $('.js-options').append(
                $(
                    "<button class='user-option-btn' data-option='" +
                        option.Id +
                        "'>" +
                        option.Description +
                        '</button>'
                )
            );
        }

        $('.user-option-btn').on('click.livesurvey', function () {
            $('.user-option-btn').removeClass('user-option-btn--active');
            $(this).addClass('user-option-btn--active');
            $('.js-selectUserOption').addClass('select-user-option-button--active');
            // Scroll to submit button when selecting an option
            $('.js-selectUserOption')[0].scrollIntoView();
            //$("html, body").animate({ scrollTop: document.body.scrollHeight }, "slow");
        });

        $('.js-selectUserOption').on('click.livesurvey', function () {
            var $selOpt = $('.user-option-btn--active');
            if (!$selOpt.length) {
                return;
            }
            var selectedOptionId = $selOpt.data('option');
            submitAnswer(activeQuestion.Id, selectedOptionId);
        });
    }

    var initUserWsListeners = function () {
        ws.onopen = function () {
            console.log('Connection open');
        };

        ws.onclose = function (e) {
            console.log('Connection closed', e);
            setActiveView('error');
        };

        ws.onmessage = function (e) {
            var message = JSON.parse(e.data);
            var phase = window.Common.PhaseIntToString(message.State.ActivePhase);
            console.log('Message received:', e, 'Parsed message:', message, 'New phase:', phase);
            updateQuestionInteraction(
                phase,
                message.ActiveQuestion,
                message.NumQuestions,
                message.NumUsers
            );
        };
    };

    var openConnection = function (url) {
        console.log('Opening websocket connection...');
        ws = new WebSocket(url);
    };

    var initUser = function (id) {
        surveyId = id;

        var wsProtocol = window.location.protocol.indexOf('https') !== -1 ? 'wss://' : 'ws://';
        openConnection(
            wsProtocol + window.location.hostname + '/API/LiveSurvey/Connect?id=' + surveyId
        );

        initUserWsListeners();
    };

    return {
        Init: initUser
    };
})();
